import { render, staticRenderFns } from "./children.vue?vue&type=template&id=5307d582"
import script from "./children.vue?vue&type=script&lang=ts"
export * from "./children.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports